import { uniqBy } from "lodash";
import { validate as validateUUID } from "uuid";

import type { Meta } from "src/pages/home/route-utils";

// Surfaced rows across the rail and narrow-viewport mounts.
export const MAX_ITEMS = 4;
export const MAX_ITEMS_COMPACT = 3;

// Audiences, syncs, and models are numeric bigints; everything else is uuid.
// A single malformed stored id would otherwise make its query fail.
export const hasValidId = (meta: Meta): boolean => {
  switch (meta.resource) {
    case "audiences":
    case "syncs":
    case "models":
      return /^\d+$/.test(meta.id);
    case "journeys":
    case "charts":
    case "dashboards":
    case "experiments":
    case "campaigns":
    case "ad-studio-projects":
    case "reports":
      return validateUUID(meta.id);
  }
};

// ISO timestamps sort lexically as chronologically; entries without one (saved
// before recency tracking) sort oldest.
export const byViewedAtDesc = (a: Meta, b: Meta): number =>
  (b.viewedAt ?? "").localeCompare(a.viewedAt ?? "");

// Merge the persisted buckets into a single ranked, deduped, top-N list.
// Return MAX_ITEMS, which may be cut further by the caller to MAX_ITEMS_COMPACT.
export const rankRecentlyViewed = (
  ...buckets: Array<Meta[] | undefined | null>
): Meta[] =>
  uniqBy(
    buckets.flatMap((bucket) => bucket ?? []),
    (meta) => `${meta.resource}-${meta.id}`,
  )
    .filter(hasValidId)
    .sort(byViewedAtDesc)
    .slice(0, MAX_ITEMS);
